export default {
  namespaced: true,
  state: () => ({
    categories: [],
    loading: false,
  }),
  getters: {
    getCategories(state) {
      return state.categories;
    },
    categories(state) {
      return state.categories;
    },
    isLoadingCategories(state) {
      return state.loading;
    },
    getCategoriesFiltered: (state) => (claims) => {
      if (claims?.Data?.Only) {
        return state.categories.filter((categories) => {
          return Object.entries(claims.Data.Only).some(
            ([dept, allowed]) => Boolean(allowed) && categories.Departamento === dept
          );
        });
      }
      return state.categories;
    },
  },
  mutations: {
    setCategories(state, data) {
      state.categories = data;
    },
    setLoading(state, status) {
      state.loading = status;
    },
  },
  actions: {
    async getCategories({ commit, rootGetters }) {
      commit("setLoading", true);
      try {
        const database = rootGetters.getFirebaseApp.database;
        const snapshot = await database.queryBuilder("PDV/Productos/Categorias");
        if (snapshot && snapshot.exists()) {
          const val = snapshot.val() || {};
          const categories = Object.entries(val)
            .filter(([, cat]) => !cat?.Dlat)
            .map(([id, cat]) => ({
              id,
              ...cat,
              label: `${cat.Nombre || ""} - ${cat.Departamento || ""}`,
            }));
          commit("setCategories", categories);
          return categories;
        } else {
          commit("setCategories", []);
          return [];
        }
      } catch (error) {
        console.error("Error al obtener Categorias:", error);
        commit("setCategories", []);
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
